import React from 'react';

import { useTranslation } from 'react-i18next';

import { IconBroom } from '@pkg/assets/icons';
import { FieldRange, type FieldRangeProps } from '@pkg/components';
import { clamp } from '@pkg/utils';

import { IconWrapper, StyledSweepSlider, SweepAction, SweepValue } from './SweepSlider.style';

export interface SweepSliderProps {
    value?: FieldRangeProps['value'];
    max?: FieldRangeProps['max'];
    disabled?: FieldRangeProps['disabled'];
    onChange?: FieldRangeProps['onChange'];
    onSweep?: () => void;
}

export function SweepSlider({ value = 0, max = 100, disabled = false, onChange, onSweep }: SweepSliderProps) {
    const [translate] = useTranslation('marketplace');

    const safeValue = clamp(0, value, max);

    const sweepDisabled = disabled || !onSweep || safeValue === 0;
    const sliderDisabled = disabled || !onChange;

    return (
        <StyledSweepSlider>
            <SweepAction
                aria-label={translate('sweep-slider-buy-cta-a11y')}
                disabled={sweepDisabled}
                onAction={onSweep}
            >
                <IconWrapper>
                    <IconBroom />
                </IconWrapper>

                <SweepValue>{safeValue}</SweepValue>
            </SweepAction>

            <FieldRange
                value={safeValue}
                max={max}
                ariaLabel={translate('sweep-slider-range-cta-a11y')}
                disabled={sliderDisabled}
                onChange={onChange}
            />
        </StyledSweepSlider>
    );
}
